/*
 * Regalo gratis nativo (reemplaza la app AOV.ai Free Gift & BXGY).
 *
 * - "Reclamar" añade el producto regalo (0 €) al carrito y refresca el drawer.
 * - Guard: si el carrito deja de cualificar (se quita el producto que da derecho
 *   al regalo) y el regalo sigue dentro, se retira automáticamente.
 *
 * La visibilidad del bloque la decide Liquid (snippets/gift-reward.liquid); este
 * script solo gestiona acciones de carrito y dispara `cart:update` para que el
 * cart-items-component de Horizon vuelva a renderizar la sección desde el servidor.
 *
 * Se carga UNA vez y de forma incondicional desde snippets/cart-drawer.liquid
 * (no dentro del bloque condicional, porque un <script> reinyectado por morph no
 * se ejecuta). Usa listeners delegados en document, así que captura el botón
 * "Reclamar" aparezca cuando aparezca.
 */
(function () {
  if (window.__giftRewardInit) return;
  window.__giftRewardInit = true;

  var GIFT_VARIANT_ID = 46441881141498;
  var TRIGGER_PRODUCT_IDS = [8622392606970, 8608596754682, 8617145860346, 8712195571962];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;

  function getCartSectionId() {
    var comp = document.querySelector('cart-items-component[data-section-id]');
    return comp ? comp.getAttribute('data-section-id') : null;
  }

  // Operación de carrito que pide las secciones renderizadas y dispara cart:update
  // CON esas secciones -> Horizon hace MORPH (no re-render completo), así el cart
  // drawer NO se cierra ni la página queda con el scroll bloqueado.
  function cartMutate(url, body) {
    var sectionId = getCartSectionId();
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT + url, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sections: (res && res.sections) || null, source: 'gift-reward' } },
          })
        );
        return res;
      });
  }

  // Tras re-renderizar el carrito, el <dialog> del drawer puede quedar abierto pero
  // SIN estado modal: se ve comprimido/diminuto arriba con la página detrás (sin el
  // fondo oscuro). Lo detectamos con :modal y, si pasó, lo reabrimos como modal para
  // restaurar su tamaño de pantalla completa. Idempotente: si ya está modal, no hace nada.
  function ensureModalDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    var dialog = drawer && drawer.querySelector('dialog.cart-drawer__dialog');
    if (!drawer || !dialog) return;
    var isModal = false;
    try {
      isModal = dialog.matches(':modal');
    } catch (e) {}
    if (dialog.open && isModal) return; // ya está bien, no tocar
    try {
      if (dialog.open) dialog.close();
    } catch (e) {}
    try {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof dialog.showModal === 'function') dialog.showModal();
    } catch (e) {}
  }

  function scheduleEnsureModalDrawer() {
    requestAnimationFrame(ensureModalDrawer);
    setTimeout(ensureModalDrawer, 150);
  }

  // "Reclamar" → añade el regalo (0 €) y refresca el drawer.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-gift-claim]');
    if (!button || busy) return;

    event.preventDefault();
    busy = true;
    button.setAttribute('disabled', '');

    cartMutate('cart/add.js', {
      items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _regalo: 'Sí' } }],
    })
      .then(function () {
        busy = false;
        scheduleEnsureModalDrawer();
      })
      .catch(function (error) {
        console.error('[gift-reward] No se pudo añadir el regalo:', error);
        button.removeAttribute('disabled');
        busy = false;
      });
  });

  // Mueve la línea del regalo al FINAL del carrito (Shopify la añade arriba por ser
  // lo último). Las operaciones de línea usan item.index (posición real), no la
  // visual, así que mover el <tr> en el DOM es seguro.
  function moveGiftLast() {
    var rows = document.querySelectorAll('tr[data-key^="' + GIFT_VARIANT_ID + ':"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var tbody = row.parentNode;
      if (tbody && tbody.lastElementChild !== row) {
        tbody.appendChild(row);
      }
    }
  }

  // Inyecta (una vez) los estilos de la línea del regalo en el carrito:
  // oculta el selector de cantidad y el botón de eliminar, y estiliza la etiqueta.
  function injectGiftLineStyles() {
    if (document.getElementById('gift-line-styles')) return;
    var s = document.createElement('style');
    s.id = 'gift-line-styles';
    s.textContent =
      '.cart-items__table-row.is-gift-line .quantity-selector,' +
      '.cart-items__table-row.is-gift-line .cart-items__remove{display:none!important;}' +
      '.cart-gift-tag{display:inline-block;font-size:11px;font-weight:600;letter-spacing:.02em;' +
      'color:#707070;background:#f0f0f0;border-radius:4px;padding:3px 8px;white-space:nowrap;}';
    document.head.appendChild(s);
  }

  // Marca la línea del regalo: clase para bloquear la cantidad + etiqueta "Regalo".
  function decorateGiftLine() {
    var rows = document.querySelectorAll('tr[data-key^="' + GIFT_VARIANT_ID + ':"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.classList.add('is-gift-line');
      var qtyCell = row.querySelector('.cart-items__quantity');
      if (qtyCell && !qtyCell.querySelector('.cart-gift-tag')) {
        var tag = document.createElement('span');
        tag.className = 'cart-gift-tag';
        tag.textContent = 'Regalo';
        qtyCell.appendChild(tag);
      }
    }
  }

  // El drawer re-renderiza de forma asíncrona (sectionRenderer); un observer
  // reposiciona el regalo en cuanto aparecen/cambian las filas. El check de
  // "ya es el último" evita bucles y lo hace un no-op cuando está colocado.
  function applyGiftDecor() {
    moveGiftLast();
    decorateGiftLine();
  }

  var giftObserver = new MutationObserver(applyGiftDecor);

  function startObserving() {
    injectGiftLineStyles();
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) {
      giftObserver.observe(comps[i], { childList: true, subtree: true });
    }
    applyGiftDecor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // Guard: retira el regalo si el carrito ya no cualifica.
  document.addEventListener('cart:update', function () {
    if (busy) return;

    fetch(ROOT + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) {
          return i.variant_id === GIFT_VARIANT_ID;
        })[0];
        if (!gift) return;

        var hasTrigger = cart.items.some(function (i) {
          return TRIGGER_PRODUCT_IDS.indexOf(i.product_id) !== -1;
        });
        if (hasTrigger) return;

        busy = true;
        cartMutate('cart/change.js', { id: gift.key, quantity: 0 })
          .then(function () {
            busy = false;
            scheduleEnsureModalDrawer();
          })
          .catch(function (error) {
            console.error('[gift-reward] No se pudo retirar el regalo:', error);
            busy = false;
          });
      })
      .catch(function () {});
  });
})();
